import Box from "@mui/material/Box";
import {useNavigate, useParams} from "react-router";
import React, {useEffect, useState} from "react";
import {Day} from "../core/Day";
import {deleteBoardById, getBoardById, getBoards, saveBoard} from "../helper_functions";
import {MAIN_BACKGROUND_COLOR, MAIN_ICON_COLOR} from "../CONSTANTS";
import SelectedBoard from "../main/SelectedBoard";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Typography from "@mui/material/Typography";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import HomeIcon from "@mui/icons-material/Home";
import Person2Icon from "@mui/icons-material/Person2";
import {IBoard, parseBoard, serializeBoard} from "../core/IBoard";
import {useSnackbar} from "notistack";
import {TextField} from "@mui/material";

export function SettingsPage(){
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [importText, setImportText] = useState('');
    const handleExport = () => {

        const boards = getBoards();

        const serializedBoards = boards.map((board) => serializeBoard(board));

        window.navigator.clipboard.writeText(JSON.stringify(serializedBoards));

        enqueueSnackbar("Your boards are under your clipboard!", { variant: 'success', preventDuplicate: true, autoHideDuration: 5000 });
    }

    const handleImport = () => {
        const goOn = window.confirm("Are you sure you want to import the provided data? This will remove/override all your existing boards...");

        if(goOn)
        {
            const encodedBoardsArray: string[] = JSON.parse(importText);
            const boards: IBoard[] = encodedBoardsArray.map((encodedBoard) => parseBoard(encodedBoard));

            if(boards.length > 0) {
                const oldBoards = getBoards();
                oldBoards.map((oldBoard) => deleteBoardById(oldBoard.id));

                boards.map((board) => saveBoard(board));
            }
            else
            {
                alert("Provided exports contains no boards... Failed to import.")
            }

            alert(`IMPORT DONE! Succesfully imported ${boards.length} boards.`)
        }
    }

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100dvw',
            height: '100dvh',
            backgroundColor: 'white',
            fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
        }}>

            <Box className={"heading"} sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <Box sx={{ p: 2, }}>
                    <img src={'carlipixa.png'} width={'auto'} height={'80px'} />
                </Box>
            </Box>

            <Box className={"settings"} sx={{ overflowY: 'scroll', flexGrow: 1 }}>
                <Box sx={{
                    borderRadius: 0,
                    mt: 2,
                    pt: 2,
                    minHeight: 'calc(100% - 2 * 8px)',  //m: 2 -> 1x m = 8px
                    backgroundColor: MAIN_BACKGROUND_COLOR
                }}>
                    <Paper sx={{mx: 2, p: 2}}>
                        <Typography variant={'h6'}>Export</Typography>
                        <Button sx={{mt: 2}} variant={'contained'} onClick={handleExport}>EXPORT ALL BOARDS</Button>
                    </Paper>
                    <Paper sx={{m: 2, p: 2}}>
                        <Typography variant={'h6'}>Import</Typography>
                        <TextField sx={{mt: 2}} fullWidth rows={9} value={importText} onChange={(e) => setImportText(e.target.value)} />
                        <Button sx={{mt: 2}} variant={'contained'} onClick={handleImport}>IMPORT</Button>
                    </Paper>
                </Box>
            </Box>

            <Box className={'navigation'} sx={{display: 'flex', p: 2, justifyContent: 'space-between'}}>
                <Box sx={{width: '100%', textAlign: 'center'}}>
                    <Button
                        size="large"
                        variant="text"
                        sx={{color: '#afafaf'}}
                        onClick={() => navigate('/') }
                    >
                        <HomeIcon />
                    </Button>
                </Box>
                <Box sx={{width: '100%', textAlign: 'center'}}>
                    <Button
                        size="large"
                        variant="text"
                        sx={{color: MAIN_ICON_COLOR}}
                        onClick={() => navigate('/settings') }
                    >
                        <Person2Icon />
                    </Button>
                </Box>
            </Box>

        </Box>
    )

}